module.exports = __webpack_public_path__ + "static/media/instagram-icon.426fec6c.svg";